module.exports = __webpack_public_path__ + "img/anzhuangbao.5c208d1c.png";